"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var olyHeadersProperties = {
  'oly-version': undefined,
  'api-version': undefined,
  os: undefined,
  platform: undefined,
  timezone: undefined,
  'x-device-id': undefined,
  'x-device-name': undefined,
  Authorization: undefined,
  fromAdmin: undefined,
  'Content-Type': undefined
};
var OLY_HEADERS_PROPERTIES = Object.keys(olyHeadersProperties);

var cleanHeaders = function cleanHeaders(keys) {
  return Object.keys(keys).reduce(function (acc, key) {
    if (OLY_HEADERS_PROPERTIES.includes(key)) {
      acc[key] = keys[key];
    }

    return acc;
  }, {});
};

var _default = cleanHeaders;
exports["default"] = _default;
//# sourceMappingURL=cleanHeaders.js.map